import axios from 'axios';
import { getLocalStorageValue } from '@/helpers/persistentStorage.js';
import { jwtTokenStorageKey } from '@/constants/persistentStorage.js';
import { apiResponseTypeEnum } from '@/constants/api.js';

export const apiRegisterInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
      config.url = window.location.origin + '/' + config.url;

      return config;
    },
    (error) => Promise.reject(error),
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error),
  );
};

export const apiRequest = (
  {
    useAuthorization = true,
    url,
    method,
    headers,
    ...options
  }) => {
  const __headers = {};

  if (useAuthorization) {
    __headers.Authorization = getLocalStorageValue(jwtTokenStorageKey);
  }

  return axios({
    url,
    method,
    headers: {
      ...__headers,
      ...headers, // e.g. headers: {"Content-Type": "application/json", .....}
    },
    ...options, // e.g. params: {....}, body: {....}, etc.
  });
};

export const getApiResponseErrorMessage = (
  responseTypeEnum = '',
  messagesPerResponseType = {},
  errorControllerCallback = null,
) =>
  (errorControllerCallback && errorControllerCallback()) ||
  messagesPerResponseType[responseTypeEnum] ||
  (responseTypeEnum === apiResponseTypeEnum.SERVER_ERROR && 'common_error_server_unavailable') ||
  'common_error_generic';
